import { request, success, failure } from './index';
import ACTION_CONSTANTS from '../../constants/actionConstants';

export function setPerformanceStartDate(payload) {
  return request(ACTION_CONSTANTS.PERFORMANCE_START_DATE, payload);
}

export function setPerformanceEndDate(payload) {
  return request(ACTION_CONSTANTS.PERFORMANCE_END_DATE, payload);
}

export function setSubmissionsStartDate(payload) {
  return request(ACTION_CONSTANTS.SUBMISSIONS_START_DATE, payload);
}

export function setSubmissionsEndDate(payload) {
  return request(ACTION_CONSTANTS.SUBMISSIONS_END_DATE, payload);
}
